import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-military-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics-m', 'age-military-calisthenics-m'],
		route: {
			path: '/military-calisthenics-m',
			name: 'male-military-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-male-military-calisthenics',
		route: {
			path: '/military-calisthenics-m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-military-calisthenics-onboarding',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'male-military-calisthenics',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-military-calisthenics-m',
	},
	upsell: {
		routeNames: ['upsell-military-calisthenics-m'],
	},
}

export default appAreaConfig
